// builderColors — the builder's 8-digit-hex color helpers, shared by the field
// cards, the properties panel and the conditional-logic drawer. The model
// stores colors as #rrggbbaa; alpha 00 means "no color".

import type { CSSProperties } from 'react';

/** Tinted chip style from an option's 8-digit hex (#rrggbbaa); alpha 00 = no
 *  color → undefined, letting the stylesheet's neutral token look apply. */
export const chipStyle = (itemColor: string): CSSProperties | undefined => {
  const h = itemColor?.startsWith('#') ? itemColor.slice(1) : '';
  if (h.length < 6 || (h.length === 8 && h.slice(6, 8).toLowerCase() === '00')) return undefined;
  const rgb = `#${h.slice(0, 6)}`;
  return { background: `${rgb}26`, color: rgb };
};

/** 8-digit hex (#rrggbbaa) → color-input rgb + 0-100 opacity. */
export const splitHex8 = (hex: string): { rgb: string; alpha: number } => {
  const h = hex?.startsWith('#') ? hex.slice(1) : '';
  if (h.length === 8) {
    return {
      rgb: `#${h.slice(0, 6)}`,
      alpha: Math.round((parseInt(h.slice(6, 8), 16) / 255) * 100),
    };
  }
  if (h.length === 6) return { rgb: `#${h}`, alpha: 100 };
  return { rgb: '#000000', alpha: 100 };
};

/** rgb + 0-100 opacity → 8-digit hex. */
export const joinHex8 = (rgb: string, alpha: number) =>
  `${rgb}${Math.round((alpha / 100) * 255)
    .toString(16)
    .padStart(2, '0')}`;
